/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rank_LabelInputs */

const th_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อันดับ`)
};

const en_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rank`)
};

const ja_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位`)
};

const zh_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const es_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puesto`)
};

const pt_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const id_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat`)
};

const fr_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rang`)
};

const tl_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puwesto`)
};

const vi_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng`)
};

const ko_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

const de_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platz`)
};

const ru_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место`)
};

const tr_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıra`)
};

const it_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const pl_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miejsce`)
};

const uk_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Місце`)
};

const hi_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const ar_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المركز`)
};

const ms_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const bn_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্থান`)
};

const zh_tw2_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const zh_hk2_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const ur_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجہ`)
};

const fa_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رتبه`)
};

const sw_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi`)
};

const nl_rank_label = /** @type {(inputs: Rank_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaats`)
};

/**
* | output |
* | --- |
* | "Rank" |
*
* @param {Rank_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const rank_label = /** @type {((inputs?: Rank_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rank_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_rank_label(inputs)
	if (locale === "ja") return ja_rank_label(inputs)
	if (locale === "zh") return zh_rank_label(inputs)
	if (locale === "es") return es_rank_label(inputs)
	if (locale === "pt") return pt_rank_label(inputs)
	if (locale === "id") return id_rank_label(inputs)
	if (locale === "fr") return fr_rank_label(inputs)
	if (locale === "tl") return tl_rank_label(inputs)
	if (locale === "vi") return vi_rank_label(inputs)
	if (locale === "ko") return ko_rank_label(inputs)
	if (locale === "de") return de_rank_label(inputs)
	if (locale === "ru") return ru_rank_label(inputs)
	if (locale === "tr") return tr_rank_label(inputs)
	if (locale === "it") return it_rank_label(inputs)
	if (locale === "pl") return pl_rank_label(inputs)
	if (locale === "uk") return uk_rank_label(inputs)
	if (locale === "hi") return hi_rank_label(inputs)
	if (locale === "ar") return ar_rank_label(inputs)
	if (locale === "ms") return ms_rank_label(inputs)
	if (locale === "bn") return bn_rank_label(inputs)
	if (locale === "zh-TW") return zh_tw2_rank_label(inputs)
	if (locale === "zh-HK") return zh_hk2_rank_label(inputs)
	if (locale === "ur") return ur_rank_label(inputs)
	if (locale === "fa") return fa_rank_label(inputs)
	if (locale === "sw") return sw_rank_label(inputs)
	if (locale === "nl") return nl_rank_label(inputs)
	return en_rank_label(inputs)
});